import React from 'react'
import PropTypes from 'prop-types'
import InputContainer from '../components/InputContainer'

const Input = props => <InputContainer {...props} type={props.type || 'text'} />

Input.propTypes = {
  suffix: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  inputStylingProps: PropTypes.any,
  disabled: PropTypes.bool,
  innerRef: PropTypes.any,
  rows: PropTypes.string,
  maxLength: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
  filter: PropTypes.bool,
  inputMode: PropTypes.string
}
Input.defaultProps = {
  label: '',
  suffix: '',
  type: 'text',
  value: '',
  error: '',
  onFocus: e => {},
  onBlur: e => {},
  placeholder: '',
  defaultValue: null,
  inputMode: 'text'
}

export default Input
